import { Route, RouteGroup } from '@billow/easy-route'
import Workflow from '@/views/home/Workflow'

export default RouteGroup({

  routes: [
    Route('/', 'home', Workflow),
  ]

})
